//@ts-ignore

type VehicleCertificateWebProps = {
  vehicle: any;
  vehicle_inspections: any;
  pdfMode?: boolean;
};

const VehicleCertificateWeb = ({
  vehicle,
  vehicle_inspections,
  pdfMode,
}: VehicleCertificateWebProps) => {
  return (
    <div id="checklist-certificate" className=" w-full">
      <div className=" w-full">
        {vehicle_inspections && vehicle_inspections.length ? (
          <Certificate
            vehicle={vehicle}
            location={vehicle.location}
            pdfMode={pdfMode}
          />
        ) : null}
      </div>
    </div>
  );
};

export default VehicleCertificateWeb;

import { Box, Grid } from '@mui/material';
import { useEffect, useRef } from 'react';
import { customAlphabet } from 'nanoid';
import { upperFirst } from 'lodash';
import { CarketaDisclosure } from 'src/@carketa/sales-packet/components/CarketaDisclosure';

const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 10);

const certificate_number = nanoid();

type CertificateProps = {
  location: any;
  vehicle: any;
  pdfMode?: boolean;
};

const Certificate = ({ location, vehicle, pdfMode }: CertificateProps) => {
  const resolution = {
    xs: {
      width: 374,
      height: 282,
    },
    md: {
      width: 828,
      height: 644,
    },
  };
  if (pdfMode) {
    resolution.md = {
      width: 1600,
      height: 1100,
    };
  }
  useEffect(() => {
    if (certificate_number) {
      const canvas = document.getElementById('canvas') as HTMLCanvasElement;
      const canvasSmall = document.getElementById(
        'canvasSmall'
      ) as HTMLCanvasElement;
      const image = new Image();
      image.src = '/img/sales-packet-cert.svg';
      const certification_signature = new Image();
      certification_signature.src = '/img/certification_signature.png';
      const carketa_logo_black = new Image();
      carketa_logo_black.src = '/img/carketa-trademark-logo-black.png';
      const carketa_logo_black_small = new Image(40, 10);
      carketa_logo_black_small.src = '/img/carketa-trademark-logo-black.png';

      const drawSmallCanvas = () => {
        if (canvasSmall) {
          const ctx = canvasSmall.getContext('2d') as CanvasRenderingContext2D;
          ctx.drawImage(image, 0, 0, resolution.xs.width, resolution.xs.height);
          ctx.drawImage(
            carketa_logo_black_small,
            resolution.xs.width / 2.8,
            25,
            125,
            40
          );

          ctx.font = '14px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `Certificate of Completion`,
            resolution.xs.width / 2,
            90
          );
          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${upperFirst(location.name ?? '')} successfully completed`,
            resolution.xs.width / 2,
            110
          );
          ctx.fillText(
            `an inspection of the following vehicle:`,
            resolution.xs.width / 2,
            125
          );

          ctx.font = '12px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `${upperFirst(vehicle.year ?? '')} ${upperFirst(
              vehicle.make ?? ''
            )} ${upperFirst(vehicle.model ?? '')} ${upperFirst(
              vehicle.trim ?? ''
            )}`,
            resolution.xs.width / 2,
            155
          );

          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(`VIN:`, resolution.xs.width / 4, 175);
          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(`${vehicle.vin}`, resolution.xs.width / 4, 190);

          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(`Body Style:`, resolution.xs.width / 1.4, 175);
          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(`${vehicle.body_style}`, resolution.xs.width / 1.4, 190);

          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(`Drivetrain:`, resolution.xs.width / 4, 210);
          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.drive_train ?? ''}`,
            resolution.xs.width / 4,
            225
          );

          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(`Trim:`, resolution.xs.width / 1.4, 210);
          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(`${vehicle.trim ?? ''}`, resolution.xs.width / 1.4, 225);

          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(`Engine:`, resolution.xs.width / 4, 245);
          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(`${vehicle.engine ?? ''}`, resolution.xs.width / 4, 260);

          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(`Transmission:`, resolution.xs.width / 1.4, 245);
          ctx.font = '10px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.transmission ?? ''}`,
            resolution.xs.width / 1.4,
            260
          );

          ctx.font = '6px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `CERTIFCATE NO: ${certificate_number}`,
            resolution.xs.width / 2.1,
            265
          );
        }
      };

      const drawCanvas = () => {
        if (canvas) {
          const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
          ctx.drawImage(image, 0, 0, resolution.md.width, resolution.md.height);
          ctx.drawImage(
            carketa_logo_black,
            resolution.md.width / 2.7,
            resolution.md.height / 10,
            resolution.md.width / 4,
            resolution.md.height / 12.5
          );
          ctx.font = `${resolution.md.height / 23}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `Certificate of Completion`,
            resolution.md.width / 2,
            resolution.md.height / 3.68
          );
          ctx.font = `${resolution.md.height / 40.25}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${upperFirst(location.name ?? '')} successfully completed`,
            resolution.md.width / 2,
            resolution.md.height / 2.86
          );
          ctx.fillText(
            `an inspection of the following vehicle:`,
            resolution.md.width / 2,
            resolution.md.height / 2.57
          );

          ctx.font = `${resolution.md.height / 32.2}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `${upperFirst(vehicle.year ?? '')} ${upperFirst(
              vehicle.make ?? ''
            )} ${upperFirst(vehicle.model ?? '')} ${upperFirst(
              vehicle.trim ?? ''
            )}`,
            resolution.md.width / 2,
            resolution.md.height / 2.14
          );

          ctx.font = `${resolution.md.height / 32.2}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `VIN:`,
            resolution.md.width / 4,
            resolution.md.height / 1.79
          );
          ctx.font = `${resolution.md.height / 40.25}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.vin}`,
            resolution.md.width / 4,
            resolution.md.height / 1.67
          );

          ctx.font = `${resolution.md.height / 32.2}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `Body Style:`,
            resolution.md.width / 1.4,
            resolution.md.height / 1.79
          );
          ctx.font = `${resolution.md.height / 40.25}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.body_style}`,
            resolution.md.width / 1.4,
            resolution.md.height / 1.67
          );

          ctx.font = `${resolution.md.height / 32.2}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `Drivetrain:`,
            resolution.md.width / 4,
            resolution.md.height / 1.46
          );
          ctx.font = `${resolution.md.height / 40.25}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.drive_train ?? ''}`,
            resolution.md.width / 4,
            resolution.md.height / 1.4
          );

          ctx.font = `${resolution.md.height / 32.2}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `Trim:`,
            resolution.md.width / 1.4,
            resolution.md.height / 1.46
          );
          ctx.font = `${resolution.md.height / 40.25}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.trim ?? ''}`,
            resolution.md.width / 1.4,
            resolution.md.height / 1.4
          );

          ctx.font = `${resolution.md.height / 32.2}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `Engine:`,
            resolution.md.width / 4,
            resolution.md.height / 1.24
          );
          ctx.font = `${resolution.md.height / 40.25}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.engine ?? ''}`,
            resolution.md.width / 4,
            resolution.md.height / 1.18
          );

          ctx.font = `${resolution.md.height / 32.2}px Inter`;
          ctx.textAlign = 'center';
          ctx.fillStyle = 'black';
          ctx.fillText(
            `Transmission:`,
            resolution.md.width / 1.4,
            resolution.md.height / 1.24
          );
          ctx.font = '12px Inter';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'gray';
          ctx.fillText(
            `${vehicle.transmission ?? ''}`,
            resolution.md.width / 1.4,
            resolution.md.height / 1.18
          );

          ctx.fillText(
            `CERTIFCATE NO: ${certificate_number}`,
            resolution.md.width / 2.1,
            resolution.md.height / 1.04
          );
        }
      };

      let imagesLoaded = 0;
      const waitForLoad = () => {
        imagesLoaded += 1;
        if (imagesLoaded === 3) {
          drawCanvas();
          drawSmallCanvas();
        }
      };

      if (image) {
        image.addEventListener('load', waitForLoad);
      }
      if (carketa_logo_black) {
        carketa_logo_black.addEventListener('load', waitForLoad);
      }
      if (carketa_logo_black_small) {
        carketa_logo_black_small.addEventListener('load', waitForLoad);
      }

      return () => {
        image.removeEventListener('load', waitForLoad);
        carketa_logo_black.removeEventListener('load', waitForLoad);
        carketa_logo_black_small.removeEventListener('load', waitForLoad);
      };
    }
    //@ts-ignore
    // eslint-disable-next-line
  }, []);

  const canvasRef = useRef(null);

  return (
    <Grid container spacing={1}>
      <Grid
        item
        xs={12}
        sx={pdfMode ? {} : { display: 'flex', justifyContent: 'center' }}
      >
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <canvas
            id="canvas"
            width={resolution.md.width}
            height={resolution.md.height}
            ref={canvasRef}
          ></canvas>
        </Box>
        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <canvas
            id="canvasSmall"
            width={resolution.xs.width}
            height={resolution.xs.height}
          ></canvas>
        </Box>
      </Grid>
      <Grid
        item
        container
        display="flex"
        justifyContent="center"
        spacing={2}
        xs={10}
        sx={pdfMode ? {} : { display: 'none' }}
      >
        <CarketaDisclosure />
      </Grid>
    </Grid>
  );
};
